import { CalendarEventModel } from "../../../entities";
import { BaseODataRepository } from "../../BaseODataRepository";

export class CalendarEventODataRepo extends BaseODataRepository<CalendarEventModel> {
  protected baseUrl = `/OData/calendarevent`;
}
